import type { Middleware } from 'redux'
import { notificationsSlice } from './notifications-slice.js'

interface PresenceState {
  presence: { activeEntityId: string | null }
}

/**
 * GH #2795 §4: a comment in the document the recipient has open arrives where they can see it, so it shows no toast.
 * Decided here, before the reducer, so a dropped comment leaves whatever toast is showing alone (Joni's audit, P2).
 */
export const notificationsMiddleware: Middleware<object, PresenceState> = store => next => action => {
  if (notificationsSlice.actions.setNotification.match(action)) {
    const documentId = (action.payload.data as { documentId?: unknown } | undefined)?.documentId
    if (documentId && documentId === store.getState().presence.activeEntityId) {
      return action
    }
  }
  return next(action)
}
